import React from 'react'
import { CredibilidadeWrapper } from '../style'
import { CustomButton } from 'styles/global'
import Marquee from 'components/Marquee'
import { HashLink } from 'react-router-hash-link'
import { scrollWithOffset } from 'util/scrollWithOffset'

const Credibilidade = () => {
  return (
    <CredibilidadeWrapper>
      <div className="container d-flex flex-column align-items-center gap-3">
        <h4 className="title">
          Riber. Há 24 anos entre os principais <br /> correspondentes bancários
          do país.
        </h4>
        <p className="description">
          Referência em confiança, agilidade levando crédito com <br />
          segurança a milhares de brasileiros.
        </p>
        <HashLink
          to="/#iniciar-simulacao"
          className="w-auto no-styled-link"
          smooth
          scroll={(el) => {
            scrollWithOffset(el, 300)
          }}
        >
          <CustomButton
            className="simulation-button"
            background="var(--verde-riber)"
            onClick={() => {
              //
            }}
            borderRadius={50}
            height="56px"
            fontSize="1.5rem"
          >
            Simular
          </CustomButton>
        </HashLink>
      </div>
      <div className="container parceiros">
        <div className="d-flex flex-column align-items-center gap-3 mw-100">
          <h5>Nossos parceiros:</h5>
          <Marquee>
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/banco_1.png"
              height={200}
            />
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/banco_2.png"
              height={200}
            />
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/banco_3.png"
              height={200}
            />
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/banco_4.png"
              height={200}
            />
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/banco_5.png"
              height={200}
            />
          </Marquee>
        </div>
      </div>
    </CredibilidadeWrapper>
  )
}

export default Credibilidade
